import { useState, useEffect } from "react";
import {
  SwipeableList,
  SwipeableListItem,
  TrailingActions,
  SwipeAction
} from "react-swipeable-list";
import "react-swipeable-list/dist/styles.css";


export default function ProfileManager({ onSelectProfile, setActiveTab }) {
  const [profiles, setProfiles] = useState([]);
  const [newName, setNewName] = useState("");
  const [ageGroup] = useState("adult");
  const [gender, setGender] = useState("male");
  const [selectedId, setSelectedId] = useState(null);

  useEffect(() => {
    const saved = JSON.parse(localStorage.getItem("profiles")) || [];
    setProfiles(saved);
  }, []);

  const saveProfiles = (list) => {
    setProfiles(list);
    localStorage.setItem("profiles", JSON.stringify(list));
  };

  const addProfile = () => {
    if (!newName) return;
    const profile = {
      id: Date.now().toString(),
      name: newName,
      type: ageGroup,
      gender: gender,
      preferences: {}
    };
    const updated = [...profiles, profile];
    saveProfiles(updated);
    setNewName("");

    // Auto-select the newly created profile
    setSelectedId(profile.id);
    if (onSelectProfile) onSelectProfile(profile);

     // ✅ Switch to Trip Details tab automatically
    if (setActiveTab) {
      setActiveTab("trip");
    }
  };

  const deleteProfile = (id) => {
    const updated = profiles.filter(p => p.id !== id);
    saveProfiles(updated);

    // If you delete the selected profile, reset selection
    if (id === selectedId) {
      setSelectedId(null);
      if (onSelectProfile) onSelectProfile(null);
    }
  };

  // Swipe actions (for mobile)
  const trailingActions = (id) => (
    <TrailingActions>
      <SwipeAction destructive={true} onClick={() => deleteProfile(id)}>
        <div className="swipe-delete">Delete</div>
      </SwipeAction>
    </TrailingActions>
  );

  const handleSelect = (profile) => {
    setSelectedId(profile.id);
    if (onSelectProfile) onSelectProfile(profile);
  };

  return (
    <div className="card">
      <h2 className="app-heading">Travelers</h2>

      {/* Add New Profile */}
      <div className="card-section">
        <input
          type="text"
          placeholder="New Traveler name"
          value={newName}
          onChange={(e) => setNewName(e.target.value)}
        />
        {/*<label>
          Age Group:
          <select value={ageGroup} onChange={(e) => setAgeGroup(e.target.value)}>
            <option value="adult">Adult</option>
            {/*<option value="child">Child</option>
            <option value="baby">Baby</option>
          </select>
        </label>*/}
        {ageGroup === "adult" && (
          <label>
            Gender:
            <select value={gender} onChange={(e) => setGender(e.target.value)}>
              <option value="male">Male</option>
              <option value="female">Female</option>
            </select>
          </label>
        )}
        <button type="button" className="primary-btn" onClick={addProfile}>
          Add Traveler
        </button>
      </div>

      {/* Profile List with Swipeable Rows */}
      <SwipeableList>
        {profiles.map((p) => (
          <SwipeableListItem
            key={p.id}
            trailingActions={trailingActions(p.id)}
          >
            <div
              className={`profile-item ${p.id === selectedId ? "active" : ""}`}
              onClick={() => handleSelect(p)}
            >
              {p.name}
              {/* desktop fallback delete button */}
              <button
                className="delete-btn"
                onClick={(e) => {
                  e.stopPropagation(); // prevent triggering select
                  deleteProfile(p.id);
                }}
              >
                Delete
              </button>
            </div>
          </SwipeableListItem>
        ))}
      </SwipeableList>
      
    </div>
  );
}
